module.exports = __webpack_public_path__ + "static/media/left-direction-img.bbf95109.svg";